<h1 class="page-title">{{ 'account.sections.expertise' | t }} <span class="beta-chip">{{ 'club.expertise.beta' | t }}</span></h1>

@if (loading) {
  <p class="muted">{{ 'account.loading' | t }}</p>
} @else if (error) {
  <p class="error-text">{{error}}</p>
  <button type="button" class="btn-pill btn-pill-outline" (click)="load()">{{ 'account.retry' | t }}</button>
} @else if (expertise) {

  <h2 class="section-title">{{ 'club.expertise.yours' | t }}</h2>
  <p class="muted">{{ 'club.expertise.rule' | t: { deals: expertise.minDeals, hot: expertise.minHot } }}</p>

  <section class="card labels">
    @if (expertCategories.length === 0) {
      <div class="no-label">
        <mat-icon class="medal">workspace_premium</mat-icon>
        <div>
          <strong>{{ 'club.expertise.none' | t }}</strong>
          <p class="muted">{{ 'club.expertise.noneHint' | t }} <a routerLink="/poster">{{ 'club.expertise.postLink' | t }}</a></p>
        </div>
      </div>
    } @else {
      <div class="label-list">
        @for (category of expertCategories; track category.category) {
          <span class="expert-label"><mat-icon>verified</mat-icon>{{ 'club.expertise.expertIn' | t: { category: categoryName(category.category) } }}</span>
        }
      </div>
    }
  </section>
  <p class="muted">{{ 'club.expertise.period' | t: { start: date(expertise.periodStart), end: date(expertise.periodEnd) } }}</p>

  @if (expertise.categories.length) {
    <h2 class="section-title">{{ 'club.expertise.progressTitle' | t }}</h2>
    <section class="card">
      @for (category of expertise.categories; track category.category) {
        <div class="category-row">
          <div class="category-head">
            <strong>{{ categoryName(category.category) }}</strong>
            @if (category.expert) {
              <span class="chip approved"><mat-icon>verified</mat-icon>{{ 'club.expertise.expert' | t }}</span>
            }
          </div>
          <div class="progress"><span [style.width.%]="progress(category)"></span></div>
          <small class="muted">{{ 'club.expertise.progress' | t: { deals: category.deals, minDeals: expertise.minDeals, hot: category.hot, minHot: expertise.minHot } }}</small>
        </div>
      }
    </section>
  }

  <h2 class="section-title">{{ 'club.expertise.whatTitle' | t }}</h2>
  <section class="card what">
    <mat-icon class="what-icon">psychology</mat-icon>
    <p>{{ 'club.expertise.intro' | t }}</p>
  </section>

  <h2 class="section-title">{{ 'club.expertise.howTitle' | t }}</h2>
  <div class="grid-2">
    @for (step of steps; track step.key) {
      <section class="card how">
        <div class="how-visual"><mat-icon>{{step.icon}}</mat-icon></div>
        <strong>{{ 'club.expertise.' + step.key + 'Title' | t }}</strong>
        <p class="muted">{{ 'club.expertise.' + step.key | t }}</p>
      </section>
    }
  </div>
}
